import React from 'react';
import {
  Grid,
  CardContent,
  Typography,
  Tooltip,
  Box,
  Card
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StatCard = styled(Card)(({ theme, color = 'primary' }) => ({
  height: '124px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  background: `linear-gradient(135deg, ${theme.palette[color].main} 0%, ${theme.palette[color].dark} 100%)`,
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-40%',
    right: '-40%',
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,0.1)',
    borderRadius: '50%'
  },
  '& .MuiCardContent-root': {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  }
}));

const StatCards = ({ cards }) => {
  return (
    <Grid container spacing={0.5} sx={{ mb: 1 }}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <StatCard color={card.color}>
            <CardContent
              sx={{ p: 1, '&:last-child': { pb: 1 }, height: '20px' }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Box>
                  <Tooltip title={card.tooltip} arrow placement='top'>
                    <Typography
                      variant='h4'
                      component='div'
                      fontWeight='bold'
                      sx={{ cursor: 'pointer' }}
                    >
                      {card.value}
                    </Typography>
                  </Tooltip>
                  <Typography
                    variant='body2'
                    sx={{ opacity: 0.9, fontSize: '0.75rem' }}
                  >
                    {card.title}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </StatCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatCards;
